import { useQuery, useMutation, useQueryClient } from "react-query";
import { atomWithQuery } from "jotai-tanstack-query"

export function useRequestProcessor() {
  const queryClient = useQueryClient();

  //use Query Wrapper 
  function useQueryWrapper(key, queryFunction, options = {}) {
    return useQuery({
      queryKey: key,
      queryFn: queryFunction,
      ...options,
    });
  }

  //use Mutation Wrapper
  function useMutationWrapper(key, mutationFunction, options = {}) {
    return useMutation({
      mutationKey: key,
      mutationFn: (variables) => mutationFunction(variables),
      onSettled: () => queryClient.invalidateQueries(key),
      ...options,
    });
  }

  // Function to create an atom with query
  function useAtomWithQueryWrapper(key, queryFunction, options = {}) {
    return atomWithQuery(() => ({
      queryKey: key,
      queryFn: queryFunction,
      ...options,
    }));
  }

  return { useQueryWrapper, useMutationWrapper, useAtomWithQueryWrapper };
}
